// Styles for transition page
export const baseStyles = {
    color: "transparent",
    textTransform: "uppercase",
    fontWeight: "700",
    WebkitTextStroke: "3px #D0D3D4",
    textStroke: "3px #D0D3D4"
}

export const desktopStyles = {
    ...baseStyles,
    fontSize: "6rem"
}

export const mobileStyles = {
    ...baseStyles,
    fontSize: "2.5rem"
}